export default __webpack_public_path__ + "static/media/com-default-pic.f7da6a99.svg";